export const workbenchRoutePatterns = {
  login: "/login",
  dashboard: "/dashboard",
  quotations: "/quotations",
  newQuotation: "/quotations/new",
  quotationEdit: "/quotations/:id/edit",
  quotationPreview: "/quotations/:id/preview",
  settings: "/settings",
  settingsSection: "/settings/:section",
} as const;

export const workbenchRoutes = {
  login: workbenchRoutePatterns.login,
  dashboard: workbenchRoutePatterns.dashboard,
  quotations: workbenchRoutePatterns.quotations,
  newQuotation: workbenchRoutePatterns.newQuotation,
  quotationEdit: (id: string) => `/quotations/${encodeURIComponent(id)}/edit`,
  quotationPreview: (id: string) => `/quotations/${encodeURIComponent(id)}/preview`,
  settings: workbenchRoutePatterns.settings,
  settingsSection: (section: string) => `/settings/${encodeURIComponent(section)}`,
} as const;
